import { dataChevronDown } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronDown = /*#__PURE__*/createIcon(dataChevronDown)
export default IconChevronDown
